module.exports = __webpack_public_path__ + "static/media/ituroo.b625beff.png";